import { useContext } from "react";
import PropTypes from "prop-types";

import { CartContext } from "../context/CartProvider";
import { LuxeContext } from "../context/LuxeProvider";
import { GeoContext } from "../context/GeoProvider";
import { cn } from "@helpers/general";

import useDiscountsInfo from "../hooks/useDiscountsInfo";
import { applyCartDiscounts } from "./cartDiscounts";
import CheckoutButton from "./sideCart/CheckoutButton";
import { ComponentType } from "../constants/ComponentType";
import DISCOUNT_TYPES from "../constants/DiscountTypes";
import TAG from "../constants/Tag";

import "./checkoutCallout/styles.scss";

async function goToCheckout(url) {
  window.location.href = url;
}
function CheckoutCallout({ componentType, saleColors, backgroundColorAB }) {
  const discountsInfo = useDiscountsInfo();
  const { cart } = useContext(CartContext);
  const {
    luxe: { isLuxeActive, hasLuxeInCart, shouldAddLuxeInNextATC },
  } = useContext(LuxeContext);
  const { gePriceDetails } = useContext(GeoContext);

  const sideCartInfo = applyCartDiscounts(cart.lines, discountsInfo);
  const { lines } = sideCartInfo;
  const isCheckoutDisabled =
    lines.length === 1 &&
    lines[0].variant.product.tags.includes(TAG.MYSTERY) &&
    lines[0].quantity === 1;

  const countryCode = gePriceDetails.CountryCode;

  const amountDiscounts = discountsInfo
    .filter((discount) => discount.type === DISCOUNT_TYPES.AMOUNT_PERCENT)
    .map((discount) => discount.discounts)
    .flat();

  const lastDiscount =
    amountDiscounts.length > 0 ? amountDiscounts[amountDiscounts.length - 1][1] : null;
  const isLuxe = isLuxeActive || hasLuxeInCart || shouldAddLuxeInNextATC;

  const isSideCart = componentType === ComponentType.SIDE_CART;

  const isFreeGiftInCart = lines.some((line) =>
    line.attributes.some((attr) => attr.key === "_free_gift" && attr.value === "true")
  );

  let message = "You've Unlocked ";
  message += isLuxe && lastDiscount ? `${lastDiscount}% Off + ` : "";
  message += "Free Shipping";
  message += isFreeGiftInCart ? " + Free Gift" : "";

  return (
    <div
      className={cn(
        isSideCart
          ? "rounded-[4px] text-left"
          : "typo-micro font-bold flex items-center justify-center gap-[15px] desktop:gap-[20px]"
      )}
      style={{
        backgroundColor: backgroundColorAB,
        color:
          componentType === ComponentType.SIDE_CART
            ? saleColors?.sidecartBannerTextColor
            : undefined,
      }}
    >
      <p className={isSideCart && "typo-micro font-bold mb-[10px] desktop:mb-[12px]"}>{message}</p>

      <CheckoutButton
        checkoutUrl={cart.checkoutUrl}
        isCheckoutDisabled={isCheckoutDisabled}
        countryCode={countryCode}
        goToCheckout={goToCheckout}
        isLuxe={isLuxe}
        saleColors={saleColors}
        buttonText={isSideCart ? "Complete Checkout Now" : "Check Out Now"}
        componentType={componentType}
      />
    </div>
  );
}

CheckoutCallout.propTypes = {
  componentType: PropTypes.string,
  saleColors: PropTypes.shape({
    sidecartBannerTextColor: PropTypes.string,
  }),
  backgroundColorAB: PropTypes.string,
};

export default CheckoutCallout;
